import { useEffect } from 'react'
import { syncOfflinePhotoQueue } from '../lib/offlinePhotoSync'

const RETRY_MS = 60_000

/** Drain the offline photo queue when online and on a timer. */
export function useOfflinePhotoSync() {
  useEffect(() => {
    const run = () => {
      void syncOfflinePhotoQueue()
    }
    run()
    window.addEventListener('online', run)
    const timer = window.setInterval(run, RETRY_MS)
    return () => {
      window.removeEventListener('online', run)
      window.clearInterval(timer)
    }
  }, [])
}
